/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "translation_types": {
            "nested": {
              "TranslationType": {
                "values": {
                  "CUSTOM_AMOUNT_ITEM": 0,
                  "UNITEMIZED_TAX": 1,
                  "DEFAULT_DISCOUNT": 2,
                  "DEFAULT_ITEM": 3,
                  "DEFAULT_SALES_TAX": 4,
                  "DEFAULT_TIP": 5,
                  "CHANGE": 6,
                  "REFUND": 7,
                  "CASH_REFUND": 8,
                  "INCLUSIVE_TAX": 9,
                  "DEFAULT_ITEM_MODIFIER": 10,
                  "CREDIT": 11,
                  "SWEDISH_ROUNDING": 12,
                  "SURCHARGE": 13,
                  "DEFAULT_DEVICE": 14,
                  "NO_CATEGORY": 15,
                  "NO_DISCOUNT": 16,
                  "NO_MODIFIER": 17,
                  "NO_SUBUNIT": 18,
                  "NO_MOBILE_STAFF": 19,
                  "NO_EMPLOYEE": 20,
                  "NAMELESS_EMPLOYEE": 78,
                  "CUSTOM_AMOUNT_ITEM_VARIATION": 21,
                  "DEFAULT_ITEM_VARIATION": 22,
                  "NO_MODIFIER_SET": 23,
                  "DEFAULT_MODIFIER_SET": 24,
                  "NO_TAX": 25,
                  "NO_DINING_OPTION": 26,
                  "NO_GIFT_CARD": 27,
                  "NO_VOID_REASON": 28,
                  "NO_COMP_REASON": 29,
                  "DEFAULT_COMP_REASON": 30,
                  "NO_COMP": 31,
                  "TICKET_NAME": 32,
                  "TICKET_GROUP_NAME": 33,
                  "NO_TICKET_GROUP": 34,
                  "NO_DEVICE_CREDENTIAL": 35,
                  "DEFAULT_DEVICE_CREDENTIAL": 36,
                  "NO_EMPLOYEE_ROLE": 37,
                  "EMPLOYEE_ROLE_ACCOUNT_OWNER_ROLE": 38,
                  "EMPLOYEE_ROLE_OWNER_ROLE": 39,
                  "EMPLOYEE_ROLE_DELETED_ROLE": 40,
                  "EMPLOYEE_ROLE_MOBILE_STAFF_ROLE": 41,
                  "NO_CONVERSATIONAL_MODE": 42,
                  "NO_MENU": 43,
                  "NO_TICKET_TEMPLATE": 44,
                  "NO_TICKET_TEMPLATE_CUSTOM_CHECK": 45,
                  "NO_PAYMENT_SOURCE_NAME": 46,
                  "UNKNOWN_PAYMENT_SOURCE_NAME": 47,
                  "NO_CONTACT_TOKEN": 48,
                  "NO_REPORTING_GROUP": 49,
                  "NO_SURCHARGE": 50,
                  "SURCHARGE_AUTO_GRATUITY": 51,
                  "DEFAULT_SURCHARGE_NAME": 52,
                  "DEFAULT_ORDER_SOURCE_NAME": 53,
                  "ORDER_SOURCE_REGISTER": 54,
                  "ORDER_SOURCE_MARKET": 55,
                  "ORDER_SOURCE_ORDER": 56,
                  "ORDER_SOURCE_EXTERNAL_API": 57,
                  "ORDER_SOURCE_APPOINTMENTS": 58,
                  "ORDER_SOURCE_INVOICES": 59,
                  "ORDER_SOURCE_BILLING": 60,
                  "ORDER_SOURCE_STORE": 61,
                  "ORDER_SOURCE_ONLINE_STORE": 62,
                  "ORDER_SOURCE_STARBUCKS": 63,
                  "ORDER_SOURCE_WHITE_LABEL": 64,
                  "ORDER_SOURCE_PAYROLL": 65,
                  "ORDER_SOURCE_CAPITAL": 66,
                  "ORDER_SOURCE_TERMINAL": 67,
                  "ORDER_SOURCE_EGIFTING": 68,
                  "ORDER_SOURCE_CASH": 69,
                  "ORDER_SOURCE_REGISTER_HARDWARE": 70,
                  "ORDER_SOURCE_SUBSCRIPTIONS": 74,
                  "ORDER_SOURCE_FNB_KIOSK": 75,
                  "DEFAULT_MEASUREMENT_UNIT": 71,
                  "NO_VENDOR": 72,
                  "UNKNOWN_VENDOR": 73,
                  "DEFAULT_COMBO": 76,
                  "NO_CHANNEL_ATTRIBUTION": 77,
                  "UNKNOWN_CHANNEL_ATTRIBUTION": 79
                }
              },
              "NameOrTranslationType": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "translationType": {
                    "type": "squareup.beemo.translation_types.TranslationType",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.translation_types?.nested?.TranslationType && !$root.nested?.squareup?.nested?.beemo?.nested?.translation_types?.nested?.NameOrTranslationType) {
  $root.addJSON(jsonData);
}

/**
 * This enumeration should be updated with an entry for any new internationalizable / fixed
 * string to be sent down by beemo in any reporting field.
 *
 * SOURCE TranslationType @ squareup/beemo/translation_types.proto at 10:1
 */
export const TranslationType = $root.lookupEnum('squareup.beemo.translation_types.TranslationType').values;
/**
 * Please use NameOrType instead.
 *
 * SOURCE NameOrTranslationType @ squareup/beemo/translation_types.proto at 132:1
 */
export const NameOrTranslationType = $root.lookupType('squareup.beemo.translation_types.NameOrTranslationType');
fixType(NameOrTranslationType);
Builder.createAndAttachToType(NameOrTranslationType);